import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Center,
  Container,
  HStack,
  List,
  ListItem,
  Text,
} from '@chakra-ui/react';
import PageHeader from 'components/page-header/PageHeader';
import PageTitleMobile from 'components/page-header/PageTitleMobile';
import { withIronSessionSsr } from 'iron-session/next';
import RootLayout from 'layouts/RootLayout';
import { sessionOptions } from 'libs/iron-session';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import { NextPageWithLayout } from './_app';

const HowToPayPage: NextPageWithLayout = () => {
  const { t } = useTranslation(['common', 'how-to-pay']);

  return (
    <>
      <Head>
        <title>{t('how-to-pay:how-to-pay:title')} | แลมป์ตั้น</title>
      </Head>
      <Box>
        <PageHeader title={t('how-to-pay:how-to-pay:title')}></PageHeader>
        <PageTitleMobile>{t('how-to-pay:how-to-pay:title')}</PageTitleMobile>
        <Container
          pt={{
            base: 8,
            md: 12,
          }}
          pb={{
            base: 8,
            md: 20,
          }}
        >
          <Text mb={4}>{t('how-to-pay:how-to-pay:description')}</Text>
          <Accordion defaultIndex={[]} allowMultiple>
            <AccordionItem borderColor="#eee">
              <AccordionButton
                py={4}
                width="100%"
                display="flex"
                justifyContent="flex-start"
              >
                <HStack spacing={4} width="100%">
                  <Center flex="0 0 60px">
                    <Image
                      src="/image-icon/credit-card.png"
                      width={40}
                      height={30}
                      alt="credit-card"
                    ></Image>
                  </Center>
                  <Text flex="1" textAlign="left">
                    {t('how-to-pay:how-to-pay:credit-card:title')}
                  </Text>
                </HStack>
              </AccordionButton>
              <AccordionPanel pb={4}>
                <Text color="gray.600" mb={5}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {t('how-to-pay:how-to-pay:credit-card:description')}
                </Text>
                <Text color="gray.600" mb={5}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {t('how-to-pay:how-to-pay:credit-card:debit_card_info')}
                </Text>
                <Text color="gray.600" mb={5}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {t('how-to-pay:how-to-pay:credit-card:otp_note')}
                </Text>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem borderColor="#eee">
              <h2>
                <AccordionButton
                  py={4}
                  width="100%"
                  display="flex"
                  justifyContent="flex-start"
                >
                  <HStack spacing={4} width="100%">
                    <Center flex="0 0 60px" pl={2}>
                      <Image
                        src="/image-icon/bank-transfer.png"
                        width={34}
                        height={20}
                        alt="bank-transfer"
                      ></Image>
                    </Center>
                    <Text>
                      {t('how-to-pay:how-to-pay:bank-transfer:title')}
                    </Text>
                  </HStack>
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Box pl={8} mb={10} mt={4}>
                  <HStack spacing={4} mb={4}>
                    <Image
                      src="/image-icon/mobile-banking.png"
                      width={34}
                      height={22}
                      alt="credit-card"
                    ></Image>
                    <Text fontWeight={400}>
                      {t(
                        'how-to-pay:how-to-pay:bank-transfer:internet_banking:title'
                      )}
                    </Text>
                  </HStack>
                  <Text mb={2}>
                    {t(
                      'how-to-pay:how-to-pay:bank-transfer:internet_banking:steps_title'
                    )}
                  </Text>
                  <List listStyleType="initial" paddingLeft={6}>
                    {Array.from({ length: 8 }).map((_, index) => (
                      <ListItem key={index}>
                        {t(
                          `how-to-pay:how-to-pay:bank-transfer:internet_banking:steps:step_${
                            index + 1
                          }`
                        )}
                      </ListItem>
                    ))}
                  </List>
                </Box>
                <Box pl={8} mb={10}>
                  <HStack spacing={4} mb={4}>
                    <Image
                      src="/image-icon/mobile-qr.png"
                      width={34}
                      height={22}
                      alt="credit-card"
                    ></Image>
                    <Text fontWeight={400}>
                      {t('how-to-pay:how-to-pay:bank-transfer:qr_code:title')}
                    </Text>
                  </HStack>
                  <Text mb={3}>
                    {t(
                      'how-to-pay:how-to-pay:bank-transfer:qr_code:description'
                    )}
                  </Text>
                  <Text mb={2}>
                    {t(
                      'how-to-pay:how-to-pay:bank-transfer:qr_code:steps_title'
                    )}
                  </Text>
                  <List listStyleType="initial" paddingLeft={6}>
                    {Array.from({ length: 7 }).map((_, index) => (
                      <ListItem key={index}>
                        {t(
                          `how-to-pay:how-to-pay:bank-transfer:qr_code:steps:step_${
                            index + 1
                          }`
                        )}
                      </ListItem>
                    ))}
                  </List>
                </Box>
                <Box pl={8}>
                  <HStack spacing={4} mb={4}>
                    <Image
                      src="/image-icon/printer.png"
                      width={34}
                      height={22}
                      alt="credit-card"
                    ></Image>
                    <Text fontWeight={400}>
                      {t(
                        'how-to-pay:how-to-pay:bank-transfer:payment_channels:title'
                      )}
                    </Text>
                  </HStack>
                  <List listStyleType="initial" paddingLeft={6} mb={3}>
                    {Array.from({ length: 10 }).map((_, index) => (
                      <ListItem key={index}>
                        {t(
                          `how-to-pay:how-to-pay:bank-transfer:payment_channels:channel_${
                            index + 1
                          }`
                        )}
                      </ListItem>
                    ))}
                  </List>
                  <Text fontWeight={500} mb={6}>
                    {t(
                      'how-to-pay:how-to-pay:bank-transfer:payment_channels:note'
                    )}
                  </Text>
                </Box>
              </AccordionPanel>
            </AccordionItem>

            {/* <AccordionItem borderColor="#eee">
              <AccordionButton
                py={6}
                width="100%"
                display="flex"
                justifyContent="flex-start"
              >
                <HStack spacing={4} width="100%">
                  <Center flex="0 0 60px">
                    <Image
                      src="/image-icon/grab-pay.png"
                      width={60}
                      height={30}
                      alt="grab"
                    ></Image>
                  </Center>
                  <Text>GRAB PAY</Text>
                </HStack>
              </AccordionButton>
            </AccordionItem> */}

            <AccordionItem borderColor="#eee">
              <AccordionButton
                py={4}
                width="100%"
                display="flex"
                justifyContent="flex-start"
              >
                <HStack spacing={4} width="100%">
                  <Center flex="0 0 60px">
                    <Image
                      src="/image-icon/truemoney.png"
                      width={60}
                      height={40}
                      alt="grab"
                    ></Image>
                  </Center>
                  <Text>TRUE MONEY</Text>
                </HStack>
              </AccordionButton>
              <AccordionPanel pb={4}>
                <Box pl={8} mb={10} mt={4}>
                  <HStack spacing={4} mb={4}>
                    <Image
                      src="/image-icon/mobile-qr.png"
                      width={34}
                      height={22}
                      alt="credit-card"
                    ></Image>
                    <Text fontWeight={400}>
                      {t('how-to-pay:how-to-pay:true-money:title')}
                    </Text>
                  </HStack>
                </Box>
                <Box pl={8} mb={6}>
                  <Text fontWeight={400} mb={3}>
                    {t('how-to-pay:how-to-pay:true-money:subtitle')}
                  </Text>
                  <Text>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    {t('how-to-pay:how-to-pay:true-money:description')}
                  </Text>
                </Box>

                <Box pl={8} mb={6}>
                  <Text fontWeight={400} mb={2}>
                    {t('how-to-pay:how-to-pay:true-money:computer_steps:title')}
                  </Text>
                  <List listStyleType="initial" paddingLeft={6}>
                    {Array.from({ length: 5 }).map((_, index) => (
                      <ListItem key={index}>
                        {t(
                          `how-to-pay:how-to-pay:true-money:computer_steps:steps:step_${
                            index + 1
                          }`
                        )}
                      </ListItem>
                    ))}
                  </List>
                </Box>

                <Box pl={8} mb={6}>
                  <Text fontWeight={400} mb={2}>
                    {t('how-to-pay:how-to-pay:true-money:phone_steps:title')}
                  </Text>
                  <List listStyleType="initial" paddingLeft={6}>
                    {Array.from({ length: 5 }).map((_, index) => (
                      <ListItem key={index}>
                        {t(
                          `how-to-pay:how-to-pay:true-money:phone_steps:steps:step_${
                            index + 1
                          }`
                        )}
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Container>
      </Box>
    </>
  );
};

HowToPayPage.getLayout = (page) => {
  return <RootLayout>{page}</RootLayout>;
};

export const getServerSideProps = withIronSessionSsr(async function ({
  req,
  res,
  locale,
}) {
  const _locale = locale || 'th';

  return {
    props: {
      ...(await serverSideTranslations(_locale, ['common', 'how-to-pay'])),
    },
  };
},
sessionOptions);

export default HowToPayPage;
